/**
 * @generated SignedSource<<375202d7fa88a34efc08aa33fdccd6f9>>
 * @relayHash d601676e3dcc73d7befb81221af8b1c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b32dd0644b85e055e24258a003eb53720850a6103b020bfac1d195d79bd1af22

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b32dd0644b85e055e24258a003eb53720850a6103b020bfac1d195d79bd1af22",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
